import { Injectable } from '@angular/core';
import { config } from 'src/configs/config';


const PREFIX = config.aplicacao+'-';

@Injectable({providedIn:'root'})
export class LocalStorageService{

    hasItem(key){
        return !!this.getItem(key);
    }

    setItem(key: string, value){
        window.localStorage.setItem(key,value)
    }

    getItem(key: string){
        return window.localStorage.getItem(key);
    }

    removeItem(key){
        window.localStorage.removeItem(key);
    }

}
